<template>

    <b-card class="rounded shadow-lg comment-card p-0 m-0 w-100 h-100">
      <b-row class="d-flex flex-row justify-content-center w-100 p-0 m-0">
        <b-col cols="8" class="d-flex flex-column align-items-center py-1 px-0 w-100">
          <span class="set-font-12 text-center" v-if="comment.user">{{ `${comment.user.name} ${comment.user.last_name}` }}</span>
        </b-col>
        <b-col cols="4" class="d-flex flex-column align-items-center py-1 px-0 w-100">
          <span v-if="parseInt(comment.status)===commentStatus.REJECTED.value"
                class="set-font-12 text-center p-2 bg-danger rounded text-light font-weight-bold">{{commentStatus.REJECTED.label}}</span>
          <span v-else-if="parseInt(comment.status)===commentStatus.APPROVED.value"
                class="set-font-12 text-center p-2 bg-success rounded text-light font-weight-bold">{{ commentStatus.APPROVED.label }}</span>
          <span v-else class="set-font-12 text-center p-2 bg-secondary rounded text-light font-weight-bold">{{ commentStatus.WAITING.label }}</span>
        </b-col>
      </b-row>
      <b-row class="w-100 p-0 m-0">
        <b-col class="d-flex flex-row align-items-center justify-content-center py-2 px-0 my-1 mx-0 w-100 border-info rounded bg-warning text-dark">
          <span>کامنت مربوط به :</span><span>{{comment.commentable_type}}</span>
        </b-col>
      </b-row>
      <b-row class="d-flex flex-row justify-content-center w-100 p-0 m-0">
        <b-col cols="4" class="d-flex flex-row justify-content-center p-1 w-100">
          <div class="justify-center" v-for="i in 5" :key="i">
            <b-icon icon="star-fill" font-scale="1" variant="dark" v-if="i<=comment.rate"/>
            <b-icon icon="star" font-scale="1" variant="dark" v-else/>
          </div>
        </b-col>
      </b-row>
      <b-row class="w-100 p-0 m-0">
        <b-col class="d-flex flex-column align-items-center py-1 px-0 w-100">
          <p class="set-font-12">{{ comment.body }}</p>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="8" class="d-flex flex-column align-items-start py-1">
          <b-button pill class="bg-info" size="sm" v-b-modal="'modal-'+comment.id">بازبینی</b-button>
        </b-col>
        <b-col cols="4" class="d-flex flex-column align-items-end py-1">
          <b-button pill class="bg-transparent text-danger" size="sm" @click="removeComment(comment)">
            <b-icon icon="trash"/>
          </b-button>
        </b-col>
      </b-row>

      <b-modal :id="'modal-'+comment.id" :ref="'modal-'+comment.id"
               centered scrollable hide-header-close
               title="بازبینی کامنت" header-bg-variant="dark"
               header-text-variant="light" @ok="onSubmit" @cancel="resetForm">

        <form @submit.stop.prevent="onSubmit">

          <b-row><b-col class="d-flex flex-row align-items-start p-2">
            <span>نام کاربر : </span>&MediumSpace;
            <span class="font-weight-bold">{{comment.user.name + ' '+ comment.user.last_name}}</span>
          </b-col></b-row>

          <b-row><b-col class="d-flex flex-column align-items-start p-2">
            <span>متن کامنت :</span>
            <b-textarea class="m-1" v-model="commentControlForm.content" v-html="commentControlForm.content" readonly/>
          </b-col></b-row>

          <b-row>

              <b-col cols="7" class="d-flex flex-row justify-content-center p-1 w-100">
                <div class="justify-center" v-for="i in 5" :key="i">
                  <b-icon icon="star-fill" font-scale="1" variant="dark" v-if="i<=comment.rate"/>
                  <b-icon icon="star" font-scale="1" variant="dark" v-else/>
                </div>
              </b-col>

            <b-col cols="5" class="my-1">
              <span v-if="comment.status===commentStatus.REJECTED.value" class="rounded px-1 text-light bg-danger">{{ commentStatus.REJECTED.label }}</span>
              <span v-else-if="comment.status===commentStatus.APPROVED.value" class="rounded px-1 text-light bg-success">{{ commentStatus.APPROVED.label }}</span>
              <span v-else class="rounded px-1 text-light bg-secondary">{{ commentStatus.WAITING.label }}</span>
            </b-col>
          </b-row>

          <form-group :validations="$v.commentControlForm.status">
            <div slot-scope="{ errors, invalid }">
              <b-form-select v-model="commentControlForm.status" :options="commentStatusOptions"/>
              <form-errors-manager :errors="errors"/>
            </div>
          </form-group>

        </form>

        <template #modal-footer="{ ok, cancel}">
          <b-row class="d-flex flex-row justify-content-around w-100">
            <b-button size="sm" variant="success" @click="ok()">
              ثبت تغییر
            </b-button>
            <b-button size="sm" variant="danger" @click="cancel()">
              انصراف
            </b-button>
          </b-row>
        </template>
      </b-modal>

    </b-card>

</template>

<script>
import CommentStatus from "@moeinmdn/mixitweb-front-modules/src/plugin/class/CommentStatus";
import {required, url} from "vuelidate/lib/validators";
import FormGroup from "../../validator/FormGroup";
import FormErrorsManager from '../../validator/FormErrorsManager.vue';

export default {
  name: "ApprovedComment",
  props: ['comment'],
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      commentStatusOptions: [
        {text: 'در انتظار تایید', value: 0},
        {text: 'تایید شده', value: 1},
        {text: 'رد شده', value: 2},
      ],
      commentControlForm: {
        id: this.comment.id,
        commentable_type: this.comment.commentable_type,
        content: this.comment.body,
        status: this.comment.status,
        previous_status: this.comment.status
      },
      commentStatus: CommentStatus
    }
  },
  validations: {
    commentControlForm: {
      status: {required},
    },
  },
  methods: {
    editComment() {
      this.$store.dispatch("Comment/updateComment", this.commentControlForm)
    },
    resetForm() {
      this.commentControlForm = {
        id: this.comment.id,
        commentable_type: this.comment.commentable_type,
        content: this.comment.body,
        status: this.comment.status,
        previous_status: this.comment.status
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.editComment()
        this.$nextTick(() => {
          this.$bvModal.hide('modal-' + this.comment.id)
          this.resetForm()
        })
      }
    },
    removeComment(comment){
      console.log(comment)
      if (confirm("آیا از حذف کامنت اطمینان دارید؟") === true) {
        this.$store.dispatch("Comment/removeComment", comment)
      }
    }
  }
}
</script>

<style scoped>
.set-font-12 {
  font-size: 12px;
}

.card-body {
  padding: 10px;
}
</style>